<script setup>
import { computed } from "vue";

import { TuInputLabeledSwitch } from "@tinyurldev/tu-ui-vue";

const emits = defineEmits(["on-form-select"]);

const props = defineProps({
  selectedForm: {
    type: String,
    default: "single",
  },
});

const selectedForm = computed({
  get() {
    return props.selectedForm;
  },
  set(value) {
    emits("on-form-select", value);
  },
});
</script>

<template>
  <TuInputLabeledSwitch
    v-model="selectedForm"
    data-test-id="dashboard_create_single_tinyurl"
    :is-block="true"
    true-label="Bulk Link"
    true-value="bulk"
    false-label="Single Link"
    false-value="single"
  />
</template>
